import { DeviationData } from "../../../Deviation/DeviationData";
import { DeviationStatistics } from "../../../Deviation/DeviationStatistics";

export class DeviationStatisticsHelper {
  static deviationStatistics: DeviationStatistics[] = [];

  static getDeviationStatistics(deviationData: DeviationData): DeviationStatistics {
    const existing = this.deviationStatistics.find((statistics) => statistics.deviation.id === deviationData.id);
    if (existing) {
      return existing;
    } else {
      const statistics = new DeviationStatistics(deviationData);
      this.deviationStatistics.push(statistics);
      return statistics;
    }
  }
}
